import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

const useLazyAnnotationsGet = (articleHeaderId) => {
  const params = { article_id: articleHeaderId };

  const queryString = new URLSearchParams(params).toString();

  const resource = `${MONOLITH_ORIGIN}/api/v2/annotation/?${queryString}`;

  return useLazyRestQuery(resource);
};

export default useLazyAnnotationsGet;
